export var MultiselectDropdownDataHooks;
(function (MultiselectDropdownDataHooks) {
    MultiselectDropdownDataHooks["MULTISELECT_DROPDOWN"] = "multiselect-dropdown";
    MultiselectDropdownDataHooks["NOTE"] = "note";
    MultiselectDropdownDataHooks["CONTENT_WRAPPER"] = "content-wrapper";
    MultiselectDropdownDataHooks["DIVIDER"] = "divider";
    MultiselectDropdownDataHooks["BUTTON"] = "button";
    MultiselectDropdownDataHooks["BUTTON_WRAPPER"] = "button-wrapper";
    MultiselectDropdownDataHooks["BUTTON_APPLY"] = "button-apply";
    MultiselectDropdownDataHooks["OPTION"] = "option";
    MultiselectDropdownDataHooks["OPTION_LABEL"] = "option-label";
    MultiselectDropdownDataHooks["OPTION_SUBTITLE"] = "option-subtitle";
    MultiselectDropdownDataHooks["OPTION_COUNTER"] = "option-counter";
})(MultiselectDropdownDataHooks || (MultiselectDropdownDataHooks = {}));
//# sourceMappingURL=MultiselectDropdownDataHooks.js.map